import { ReactNode, useCallback, useReducer } from 'react';

import { createCtx, LoadingOverlay } from '@pletly/ui';

const initialState = {
	show: false,
	text: '',
};

type ContextType = {
	showLoadingOverlay: (text?: string) => void;
	closeLoadingOverlay: () => void;
	loading: boolean;
};

const [useLoadingOverlay, LoadingOverlayDataProvider] = createCtx<ContextType>();

const LoadingOverlayProvider = ({ children }: { children?: ReactNode }) => {
	const [state, dispatch] = useReducer(reducer, initialState);

	const close = useCallback(() => {
		dispatch({ type: 'hide' });
	}, [dispatch]);

	const show = useCallback(
		(text?: string) => {
			dispatch({
				type: 'show',
				payload: {
					text,
				},
			});
		},
		[dispatch],
	);

	return (
		<LoadingOverlayDataProvider
			value={{ showLoadingOverlay: show, closeLoadingOverlay: close, loading: state.show }}
		>
			{children}
			<LoadingOverlay {...state} />
		</LoadingOverlayDataProvider>
	);
};

const reducer = (state = initialState, action: Action) => {
	switch (action.type) {
		case 'show':
			return {
				...state,
				show: true,
				text: action.payload.text || '',
			};
		case 'hide':
			return initialState;

		default:
			return initialState;
	}
};

type Action = { type: 'show'; payload: { text?: string } } | { type: 'hide' };

export { LoadingOverlayProvider, useLoadingOverlay };
